import UpdateDataRoomDrawer from './UpdateDataRoomDrawer.component';

export default UpdateDataRoomDrawer;